import React, { useEffect } from "react";
import { useSelector } from 'react-redux';
import { Grid, CircularProgress, Container } from '@material-ui/core';

import Project from "./Project/Project"
import useStyles from './styles';
// import useCommonStyles from './../CommonStyle/commonStyle';
import { store } from '../../index';


type RootState = ReturnType<typeof store.getState>;

//@ts-ignore
const Projects = ({ setCurrentId }) => {
    const { projects, isLoading } = useSelector((state: RootState) => state.projects);
    const classes = useStyles();
    // const commonClasses = useCommonStyles();
    console.log(projects);
    useEffect(() => {
        // //@ts-ignore
        // if (project) setProjectData(project);
    }, [projects]);
    // console.log(posts);
    if (!projects.length && !isLoading) return (<h5>検索に当てはまるプロジェクトはありません。</h5>);
    return (
        isLoading ? <CircularProgress /> : (
            <Grid className={classes.mainContainer} justifyContent="center" container alignItems="stretch" spacing={10}>
                {projects.map((project, index) => (   
                    <Container className={classes.cardParent}>
                        <Project project={project} setCurrentId={setCurrentId}/>
                    </Container>

                ))}
            </Grid>
        )
    );
}

export default Projects;